import { provideWidgetClass } from "scrivito"

export const CenterWidget = provideWidgetClass("CenterWidget", {
  attributes: {
    content: "widgetlist"
  }
})
